import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { onError } from "apollo-link-error";

import { auth } from "../firebaseConfig";
import defaults from "./defaults";
import resolvers from "./resolvers";

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP,
});

const authLink = setContext(async (_, { headers }) => {
  let theHeader = {
    headers: {
      ...headers,
    },
  };

  if (auth.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken();
      if (token) {
        theHeader.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.log(error);
    }
  }

  return theHeader;
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message }) => {
      if (message.indexOf("Not authenticated") > -1) {
        console.log("Caught unauthorized error");
        auth.signOut();
      }
    });
  }
});

const cache = new InMemoryCache();

export const apolloClient = new ApolloClient({
  cache,
  resolvers,
  link: ApolloLink.from([authLink, errorLink, httpLink]),
  connectToDevTools: true,
});

cache.writeData({
  data: {
    ...defaults,
  },
});

apolloClient.onResetStore(() => cache.writeData({ data: { ...defaults } }));
